import FrameworkCourseController from '../../../framework-course.controller';

class Diagram1Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 3;
    this.first = true;
    this.clearDiagramId = 1
    this.exerciseId = 'exercise-1'
    this.pyramidData = {
      exerciseNumber: 1,
      scheme: {
        model: {
          textarea: 'Should be able to build on our existing market presence to emerge as market leader',
        },
        children: [
          {
            model: {
              textarea: 'Focus on K-5 enrichment curriculum in the Arts and Sciences',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Offer innovative hybrid-fee-based model',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Market directly through RI\'s Kids\' Place stores',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Keep tight control over operations and costs',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'Sit',
        'c-header': 'R1, DE, R2'
      },
    };
  }

}

export default Diagram1Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram1/diagram1.controller.js